import React, { FunctionComponent } from 'react';

const PlayIcon: FunctionComponent = () => (
  <svg className="w-10 fill-current xl:w-12" viewBox="0 0 10 12">
    <polygon fillRule="evenodd" points="0 1 0 11 9 6" />
  </svg>
);

export default PlayIcon;
